import { render } from "./MoveDish.vue?vue&type=template&id=3a0eca30&scoped=true"
import script from "./MoveDish.vue?vue&type=script&lang=js"
export * from "./MoveDish.vue?vue&type=script&lang=js"

import "./MoveDish.vue?vue&type=style&index=0&id=3a0eca30&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a0eca30"]])

export default __exports__